import { translations } from '@aws-amplify/ui-react';
import { Typography } from '@mui/material';
import { I18n } from 'aws-amplify/utils';
import Logo from './logo.png';
import StyledBox from './styles';

I18n.putVocabularies(translations);
I18n.putVocabulariesForLanguage('fr', {
  'signup.title': 'Créez votre compte CogNeed',
  'signup.organisation': 'Nom de votre entreprise',
  'signup.password': 'Entrez votre mot de passe',
  'signup.email': 'Entrez votre adresse e-mail',
  'signup.confirm_password': 'Confirmez votre mot de passe',
  'signup.password_error': 'Le mot de passe doit contenir au moins 8 caractères, une lettre majuscule, une lettre minuscule, un chiffre, un caractère symbole.',
  'signup.organisation_error': 'Le nom de votre entreprise ne doit pas contenir des caractères spéciaux',

});
I18n.putVocabulariesForLanguage('en', {
  'signup.title': 'Create your CogNeed account',
  'signup.organisation': 'Name of your company',
  'signup.password': 'Enter your password',
  'signup.email': 'Enter your email address',
  'signup.confirm_password': 'Please confirm your password',
  'signup.password_error': 'The password must contain at least 8 characters, an uppercase letter, a lowercase letter, a number, a symbol character.',
  'signup.organisation_error': 'The name of your company must not contain special characters',
});

export default function SignUpHeader() {
  return (
    <StyledBox maxWidth="sm">
      <div className="logo">
        <img src={Logo} style={{ width: '100%', height: 'auto' }} alt="CogNeed logo" />
      </div>
      <Typography variant="h1">
        {I18n.get('signup.title')}
      </Typography>
    </StyledBox>
  );
}
